function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 2.974C2 1.884 2.844 1 3.886 1h8.228C13.156 1 14 1.884 14 2.974v11.488c0 .186-.092.36-.244.458a.495.495 0 01-.5.023l-2.513-1.315-2.513 1.315a.494.494 0 01-.46 0l-2.513-1.315-2.513 1.315a.494.494 0 01-.5-.023A.545.545 0 012 14.46V2.974zm1.886-.897c-.474 0-.857.402-.857.897V13.59l1.998-1.046a.494.494 0 01.46 0L8 13.86l2.513-1.316a.494.494 0 01.46 0l1.998 1.046V2.974c0-.495-.383-.897-.857-.897H3.886z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.257 4.41a.527.527 0 00-.514-.538H5.257a.527.527 0 00-.514.538c0 .298.23.539.514.539h5.486a.527.527 0 00.514-.539zM9.43 6.564a.527.527 0 00-.515-.538H5.257a.527.527 0 00-.514.538c0 .297.23.539.514.539h3.657a.527.527 0 00.515-.539zM7.6 8.718a.527.527 0 00-.514-.539H5.257a.527.527 0 00-.514.539c0 .297.23.538.514.538h1.829a.527.527 0 00.514-.538z"
}));
function SvgComprobante(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Comprobante.svg";
export { SvgComprobante as ReactComponent };